import styled from 'styled-components';
import Screen from '@shared/utils/screen';

const SelectViewContainer = styled.div`
  background: #242424;
  border-radius: ${22 * Screen.widthRatio}px;
  height: ${317 * Screen.widthRatio}px;
  width: ${472 * Screen.widthRatio}px;
  align-items: center;
  display: flex;
  flex-direction: column;

  & > svg {
    margin-top: ${32 * Screen.widthRatio}px !important;
  }
  & > span {
    margin-top: ${20 * Screen.widthRatio}px;
  }
`;

export default SelectViewContainer;
